import React from 'react';
import styled from 'styled-components';

const StyleSpan = styled.span`
  position: relative;
  display: inline-block;

  .whatsapp-share {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export default ({ className, isShare }) => (
  <StyleSpan className={className}>
    <svg viewBox="0 0 51.3 51.97">
      <g>
        <path d="M25.65,51.02c-4.45,0-8.79-1.17-12.61-3.4L1.39,50.79L5.2,40.43c-1.38-1.95-2.47-4.08-3.24-6.33
          c-0.89-2.6-1.34-5.33-1.34-8.11c0-3.38,0.66-6.66,1.97-9.74c1.26-2.98,3.07-5.66,5.36-7.96s4.98-4.1,7.96-5.36
          c3.09-1.31,6.37-1.97,9.74-1.97c3.38,0,6.66,0.66,9.74,1.97c2.98,1.26,5.66,3.07,7.96,5.36c2.3,2.3,4.1,4.98,5.36,7.96
          c1.31,3.09,1.97,6.37,1.97,9.74c0,3.38-0.66,6.66-1.97,9.74c-1.26,2.98-3.07,5.66-5.36,7.96c-2.3,2.3-4.98,4.1-7.96,5.36
          C32.31,50.36,29.03,51.02,25.65,51.02z M13.5,44.4l0.55,0.34c3.48,2.15,7.49,3.29,11.6,3.29c12.16,0,22.05-9.89,22.05-22.05
          c0-12.16-9.89-22.05-22.05-22.05S3.6,13.83,3.6,25.99c0,4.85,1.54,9.45,4.46,13.3l0.49,0.65L6.18,46.4L13.5,44.4z"/>
        <g>
          <path d="M16.99,13.04c0.56-0.2,1.19-0.12,1.7,0.16c0.31,0.17,0.54,0.44,0.79,0.68c1.26,1.26,2.53,2.53,3.79,3.79
            c0.38,0.39,0.63,0.92,0.62,1.47c0.02,0.45-0.14,0.89-0.38,1.27c-0.16,0.21-0.33,0.42-0.53,0.6c-0.61,0.61-1.23,1.22-1.83,1.84
            c0.17,0.37,0.4,0.72,0.59,1.08c0.2,0.36,0.42,0.71,0.64,1.06c0.77,1.26,1.72,2.42,2.77,3.46c0.97,0.95,2.04,1.81,3.21,2.52
            c0.69,0.45,1.4,0.84,2.13,1.23c0.68-0.68,1.37-1.37,2.05-2.05c0.25-0.25,0.55-0.46,0.9-0.57c0.52-0.2,1.12-0.16,1.62,0.08
            c0.39,0.17,0.68,0.51,0.98,0.8c1.25,1.25,2.5,2.5,3.75,3.75c0.39,0.38,0.61,0.92,0.62,1.46v0.1c-0.01,0.32-0.11,0.63-0.25,0.92
            c-0.27,0.53-0.75,0.89-1.16,1.31c-0.19,0.17-0.35,0.39-0.58,0.5c-0.6,0.44-1.28,0.79-1.99,1.02c-0.33,0.13-0.68,0.18-1.03,0.25
            c-0.38,0.08-0.77,0.09-1.16,0.05c-0.49,0-0.97-0.08-1.45-0.15c-0.43-0.05-0.84-0.18-1.26-0.27c-0.42-0.13-0.84-0.23-1.25-0.4
            c-0.52-0.15-1.01-0.39-1.52-0.6c-0.45-0.21-0.9-0.44-1.35-0.67c-0.61-0.36-1.24-0.7-1.82-1.1c-0.73-0.45-1.39-0.99-2.08-1.5
            c-0.75-0.61-1.48-1.24-2.18-1.91c-0.65-0.59-1.24-1.25-1.86-1.88c-1.76-1.89-3.44-3.91-4.62-6.22c-0.59-1.19-1.06-2.45-1.26-3.77
            c-0.17-0.94-0.18-1.9-0.08-2.84c0.1-1.27,0.55-2.51,1.31-3.54c0.07-0.1,0.11-0.22,0.2-0.31c0.32-0.32,0.64-0.64,0.95-0.95
            C16.26,13.4,16.59,13.15,16.99,13.04z"/>
        </g>
      </g>
    </svg>
    {!!isShare && <div className="whatsapp-share"></div>}
  </StyleSpan>
)